import React from 'react';
import { Link } from 'react-router-dom';
import { FaCode, FaMobileAlt, FaShoppingCart, FaGlobe, FaLaptopCode, FaStore, FaArrowRight, FaPlug, FaServer, FaBolt, FaChartBar, FaNetworkWired, FaUserTie, FaShopify, FaRobot, FaCreditCard } from 'react-icons/fa';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: <FaLaptopCode />,
      title: 'Full-Stack Web App Development',
      description: 'Build dynamic, high-performance applications with modern tech. Perfect for startups, SaaS, dashboards, admin panels, booking systems, and more. Scalable, secure, and built for growth.',
      color: '#00d4ff',
      link: '/service/full-stack-web-app'
    },
    {
      icon: <FaGlobe />,
      title: 'Static Website Development',
      description: 'Fast, clean, SEO-friendly websites for businesses, brands, portfolios, and personal use. Quick delivery + affordable pricing.',
      color: '#a855f7',
      link: '/service/static-website'
    },
    {
      icon: <FaMobileAlt />,
      title: 'Static Android & iOS App Development',
      description: 'Simple, stylish mobile apps ideal for businesses that want presence on app stores without heavy development. Affordable. Lightweight. Effective.',
      color: '#f093fb',
      link: '/service/static-mobile-app'
    },
    {
      icon: <FaCode />,
      title: 'Full-Stack Mobile App Development (Android & iOS)',
      description: 'Complete app ecosystem with backend, admin panel, APIs, authentication, and premium UI. Enterprise-grade performance without enterprise pricing.',
      color: '#4facfe',
      link: '/service/full-stack-mobile-app'
    },
    {
      icon: <FaShoppingCart />,
      title: 'E-Commerce Website Development',
      description: 'Create powerful online stores with secure payments, product management, inventory, order tracking, and dashboards. Built to convert and scale.',
      color: '#43e97b',
      link: '/service/ecommerce-website'
    },
    {
      icon: <FaStore />,
      title: 'E-Commerce Mobile Apps (Android & iOS)',
      description: 'Shopping apps with cart, checkout, payments, push notifications, clean UI, and a smooth buying experience. Boost sales with a mobile-first approach.',
      color: '#fa709a',
      link: '/service/ecommerce-mobile-app'
    },
    {
      icon: <FaPlug />,
      title: 'API Development',
      description: 'RESTful and GraphQL APIs built for performance, security, and scalability. Connect your applications with robust backend services.',
      color: '#00d4ff',
      link: '/service/api-development'
    },
    {
      icon: <FaServer />,
      title: 'Backend Microservices',
      description: 'Scalable microservices architecture for complex applications. Independent, deployable services that work together seamlessly.',
      color: '#a855f7',
      link: '/service/backend-microservices'
    },
    {
      icon: <FaBolt />,
      title: 'Realtime Apps (Socket.io, Firebase)',
      description: 'Real-time applications with instant updates, live chat, notifications, and collaborative features using Socket.io and Firebase.',
      color: '#f093fb',
      link: '/service/realtime-apps'
    },
    {
      icon: <FaChartBar />,
      title: 'Custom Dashboards & Analytics',
      description: 'Powerful data visualization dashboards with real-time analytics, custom metrics, and insights to drive business decisions.',
      color: '#4facfe',
      link: '/service/custom-dashboards'
    },
    
    {
      icon: <FaUserTie />,
      title: 'Technical Consulting',
      description: 'Expert technical guidance on architecture, scalability, security, and best practices to optimize your development process.',
      color: '#fa709a',
      link: '/service/technical-consulting'
    },
    {
      icon: <FaShopify />,
      title: 'Shopify Development',
      description: 'Custom Shopify store development, theme customization, app integration, and optimization to boost your e-commerce sales.',
      color: '#95bf47',
      link: '/service/shopify-development'
    },
    
    {
      icon: <FaCreditCard />,
      title: 'Payment Integrations',
      description: 'Seamless payment gateway integrations including Razorpay, Stripe, Cashfree, PhonePe, PayU, and Paytm for secure transactions.',
      color: '#4ecdc4',
      link: '/service/payment-integrations'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="services-container">
        <div className="services-header" data-aos="fade-up">
          <h2 className="section-title">What We Offer</h2>
          <p className="section-subtitle">
            Comprehensive development solutions tailored to your business needs
          </p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <Link
              key={index}
              to={service.link}
              className="service-card"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div 
                className="service-icon"
                style={{ background: `linear-gradient(135deg, ${service.color} 0%, ${service.color}dd 100%)` }}
              >
                {service.icon}
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <div className="service-link-arrow">
                <span>Learn More</span>
                <FaArrowRight />
              </div>
              <div className="service-hover-effect"></div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;

